module.exports = __webpack_public_path__ + "img/vx-provider-logotype.1670bb7c.png";